/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MatchQuestionPagedData } from '../../models/match-question-paged-data';

export interface GetMatchQuestions$Params {
  PageNumber?: number;
  PageSize?: number;
}

export function getMatchQuestions(http: HttpClient, rootUrl: string, params?: GetMatchQuestions$Params, context?: HttpContext): Observable<StrictHttpResponse<MatchQuestionPagedData>> {
  const rb = new RequestBuilder(rootUrl, getMatchQuestions.PATH, 'get');
  if (params) {
    rb.query('PageNumber', params.PageNumber, {});
    rb.query('PageSize', params.PageSize, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MatchQuestionPagedData>;
    })
  );
}

getMatchQuestions.PATH = '/matchquestion';
